import * as tslib_1 from "tslib";
import { saveConversationsOptionQuick } from '../actions/saveConversationsOption';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var CONVERSATION_VIEW_OFF_KEY = 'Off';
var ConversationsQuick = /** @class */ (function (_super) {
    tslib_1.__extends(ConversationsQuick, _super);
    function ConversationsQuick() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            if (option.key === CONVERSATION_VIEW_OFF_KEY) {
                saveConversationsOptionQuick(false);
            }
            else {
                saveConversationsOptionQuick(true, option.key);
            }
        };
        return _this;
    }
    ConversationsQuick.prototype.render = function () {
        var userOptions = this.props.userOptions;
        var selectedKey = userOptions.GlobalListViewTypeReact === 1 /* Message */
            ? CONVERSATION_VIEW_OFF_KEY
            : userOptions.ConversationSortOrderReact;
        return (React.createElement(ChoiceGroup, { "aria-labelledby": this.props.headerAriaId, selectedKey: selectedKey, options: [
                {
                    key: 'ChronologicalNewestOnTop',
                    text: strings.options_conversations_quick_sortOrderTop,
                },
                {
                    key: 'ChronologicalNewestOnBottom',
                    text: strings.options_conversations_quick_sortOrderBottom,
                },
                {
                    key: CONVERSATION_VIEW_OFF_KEY,
                    text: strings.options_conversations_quick_messageView,
                },
            ], onChange: this.onChange }));
    };
    ConversationsQuick = tslib_1.__decorate([
        reactive({
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], ConversationsQuick);
    return ConversationsQuick;
}(React.Component));
export default ConversationsQuick;
//# sourceMappingURL=ConversationsQuick.js.map